var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoom = function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#zoom_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.11 4.005c3.007 0 5.73 1.22 7.7 3.19a10.855 10.855 0 0 1 3.19 7.7c0 3.006-1.219 5.729-3.19 7.7a10.857 10.857 0 0 1-7.7 3.189c-2.693 0-5.158-.979-7.06-2.598a.913.913 0 0 1-.095.113l-4.44 4.446a.887.887 0 0 1-1.257-1.25l4.44-4.446a.917.917 0 0 1 .118-.1 10.846 10.846 0 0 1-2.596-7.055c0-3.006 1.22-5.729 3.19-7.7a10.856 10.856 0 0 1 7.7-3.19Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.553 8.451a9.084 9.084 0 0 0-6.443-2.668 9.084 9.084 0 0 0-6.443 2.668 9.084 9.084 0 0 0-2.669 6.443 9.084 9.084 0 0 0 2.669 6.443 9.084 9.084 0 0 0 6.443 2.668 9.084 9.084 0 0 0 6.443-2.668 9.084 9.084 0 0 0 2.669-6.443 9.084 9.084 0 0 0-2.669-6.443Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.875v8.25M21 14.875h4.125M16.99 14.875h4.125",
    stroke: "#777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "zoom_svg__a",
    x: 0,
    y: 0,
    width: 40,
    height: 40.006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4633_16082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4633_16082",
    result: "shape"
  })))));
};
export default SvgZoom;